// src/App.jsx 
import React, { useEffect } from 'react'; 
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom'; 
import Header from './components/Common/Header'; 
import Footer from './components/Common/Footer'; 
import HomePage from './pages/HomePage'; 
import CartPage from './pages/CartPage'; 
import CheckoutPage from './pages/CheckoutPage'; 
import ProductListingPage from './pages/ProductListingPage'; 
import ProductDetailPage from './pages/ProductDetailPage'; 
import WishlistPage from './pages/WishlistPage'; 
import SearchResultsPage from './pages/SearchResultsPage';  
import OffersPage from './pages/OffersPage'; 
import Login from './components/User/Login'; 
import ProfilePage from './pages/ProfilePage'; 
import AddressesPage from './pages/AddressesPage'; 
import OrdersPage from './pages/OrdersPage'; 
import OrderDetailsPage from './pages/OrderDetailsPage'; 
import { CartProvider } from './context/CartContext'; 
import { UserProvider } from './context/UserContext'; 
import { WishlistProvider } from './context/WishlistContext'; 
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsConditionsPage from './pages/TermsConditionsPage';
import ReturnPolicyPage from './pages/ReturnPolicyPage';
import ShippingInfoPage from './pages/ShippingInfoPage';
import PaymentOptionsPage from './pages/PaymentOptionsPage';
import ContactUsPage from './pages/ContactUsPage';
import AboutUsPage from './pages/AboutUsPage'; // Newly added import

const ScrollToTop = () => {   
  const { pathname } = useLocation();   
  useEffect(() => {     
    window.scrollTo(0, 0);   
  }, [pathname]);   
  return null; 
}

function App() {   
  return (     
    <UserProvider>       
      <CartProvider>         
        <WishlistProvider>           
          <BrowserRouter>             
            <ScrollToTop />              
            <div className="flex flex-col min-h-screen bg-[#f0f7f0] text-[#1a1a2e] font-sans relative">               
              <Header />               
              <main className="flex-1 pb-5 w-full px-2 md:px-6 pt-4">                 
                <Routes>                   
                  <Route path="/" element={<Navigate to="/quick" replace />} />                   
                  <Route path="/quick" element={<HomePage />} />                   
                  <Route path="/standard" element={<HomePage />} />                   
                  <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />                   
                  <Route path="/terms-conditions" element={<TermsConditionsPage />} />
                  <Route path="/return-policy" element={<ReturnPolicyPage />} />
                  <Route path="/shipping-info" element={<ShippingInfoPage />} />
                  <Route path="/payment-options" element={<PaymentOptionsPage />} />
                  <Route path="/contact-us" element={<ContactUsPage />} />
                  <Route path="/about-us" element={<AboutUsPage />} /> {/* Newly added route */}
                  <Route path="/products" element={<ProductListingPage />} />                   
                  <Route path="/product/:id" element={<ProductDetailPage />} />                   
                  <Route path="/search" element={<SearchResultsPage />} />                   
                  <Route path="/offers" element={<OffersPage />} />                   
                  <Route path="/cart" element={<CartPage />} />                   
                  <Route path="/wishlist" element={<WishlistPage />} />                   
                  <Route path="/checkout" element={<CheckoutPage />} />                   
                  <Route path="/login" element={<Login />} />                   
                  <Route path="/profile" element={<ProfilePage />} />                   
                  <Route path="/addresses" element={<AddressesPage />} />                   
                  <Route path="/orders" element={<OrdersPage />} />                   
                  <Route path="/orders/:globalOrderId" element={<OrderDetailsPage />} />                 
                </Routes>               
              </main>               
              <Footer />             
            </div>           
          </BrowserRouter>         
        </WishlistProvider>       
      </CartProvider>     
    </UserProvider>   
  ); 
}

export default App;